import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  id: "divGroupAdminUser",
  class: "divGroupAdminUser"
}
const _hoisted_4 = {
  id: "tblGroupAdminUser",
  style: {"border":"none"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "groupId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Group "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { style: {"text-align":"left"} }
const _hoisted_7 = {
  key: 1,
  class: "form-control",
  style: {"height":"30px","width":"50%"},
  id: "groupId"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_9 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_10 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("User ID "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { style: {"text-align":"left"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_14 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_15 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Employee Number "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { style: {"text-align":"left"} }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_21 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_22 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "givenName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Given Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { style: {"text-align":"left"} }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_28 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_29 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "familyName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Family Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_31 = { style: {"text-align":"left"} }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_35 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_36 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "email",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("E-mail "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_38 = { style: {"text-align":"left"} }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_42 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_43 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_44 = { style: {"margin-left":"30%","margin-right":"30%"} }
const _hoisted_45 = { class: "mb-3 row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading.value == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.pageTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", _hoisted_6, [
            ($setup.flgType!='Edit')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: "form-control",
                  style: {"height":"30px","width":"50%"},
                  id: "groupId",
                  maxlength: "8",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.groupId) = $event))
                }, null, 512 /* NEED_PATCH */)), [
                  [_vModelText, $setup.groupId]
                ])
              : (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString($setup.groupId), 1 /* TEXT */))
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.groupIdError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_11,
          _createElementVNode("td", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "userId",
              maxlength: "8",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userId) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.getEditUserInfo($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.userId]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString($setup.userIdError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "empNumber",
              maxlength: "6",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.empNumber) = $event)),
              disabled: $setup.flgType=='Edit'
            }, null, 8 /* PROPS */, _hoisted_18), [
              [_vModelText, $setup.empNumber]
            ])
          ]),
          _hoisted_19
        ]),
        _createElementVNode("tr", null, [
          _hoisted_20,
          _createElementVNode("td", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString($setup.empNumberError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_23,
          _createElementVNode("td", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "givenName",
              maxlength: "100",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.givenName) = $event)),
              onKeydown: _cache[5] || (_cache[5] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[6] || (_cache[6] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkAlphabet($event))),
              disabled: $setup.flgType=='Edit'
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_25), [
              [_vModelText, $setup.givenName]
            ])
          ]),
          _hoisted_26
        ]),
        _createElementVNode("tr", null, [
          _hoisted_27,
          _createElementVNode("td", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString($setup.givenNameError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_30,
          _createElementVNode("td", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "familyName",
              maxlength: "100",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.familyName) = $event)),
              onKeydown: _cache[9] || (_cache[9] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[10] || (_cache[10] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[11] || (_cache[11] = ($event: any) => ($setup.checkAlphabet($event))),
              disabled: $setup.flgType=='Edit'
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32), [
              [_vModelText, $setup.familyName]
            ])
          ]),
          _hoisted_33
        ]),
        _createElementVNode("tr", null, [
          _hoisted_34,
          _createElementVNode("td", _hoisted_35, [
            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.familyNameError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_37,
          _createElementVNode("td", _hoisted_38, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "email",
              maxlength: "100",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.email) = $event)),
              disabled: $setup.flgType=='Edit'
            }, null, 8 /* PROPS */, _hoisted_39), [
              [_vModelText, $setup.email]
            ])
          ]),
          _hoisted_40
        ]),
        _createElementVNode("tr", null, [
          _hoisted_41,
          _createElementVNode("td", _hoisted_42, [
            _createElementVNode("span", _hoisted_43, _toDisplayString($setup.emailError), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btnBack",
          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.backbtn()))
        }, " Back "),
        ($setup.flgType=='Edit')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary btnAdd",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.AddUpdateGroup('Edit')))
            }, " Update "))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary btnAdd",
              onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.AddUpdateGroup('Add')))
            }, " Add "))
      ])
    ])
  ]))
}